// Relative to the axios base URL, which already appends /api.
export const CLIENT_MESSAGING_SETTINGS_ENDPOINTS = {
	/** Channels, templates and defaults this deployment offers. */
	options: "client-messaging-settings/options",
	/** GET: settings of the given clients. PUT: one change applied to every listed client. */
	settings: "client-messaging-settings",
} as const;
